export default {
  // Common / Navigation
  siteName: "CSSBuy Spreadsheet",
  siteSubtitle: "Ressourcen Center",
  nav: {
    home: "Startseite",
    categories: "Kategorien",
    products: "Produkte",
    guides: "Ratgeber",
    reviews: "Bewertungen",
    shipping: "Versand",
    qc: "QC",
    sellers: "Verkäufer",
    safety: "Sicherheit",
    shoppingGuide: "Einkaufsratgeber",
    language: "Sprache",
  },
  cta: {
    explore: "CSSBuy Spreadsheet entdecken",
    guides: "CSSBuy Guides ansehen",
    buyNow: "Jetzt Kaufen",
    visitMain: "Hauptseite besuchen",
    readMore: "Mehr lesen",
    search: "Suche",
  },
  footer: {
    disclaimer: "cssbuybr.quest ist eine unabhängige Informationsressource und nicht mit CSSBuy verbunden oder von CSSBuy unterstützt, es sei denn, es wird ausdrücklich angegeben.",
    links: {
      spreadsheet: "CSSBuy Spreadsheet",
      products: "Produkte",
      sellers: "Verkäufer",
      guides: "Ratgeber",
      reviews: "Bewertungen",
      shipping: "Versand",
      qc: "QC",
      comparisons: "Vergleiche",
      safety: "Sicherheit",
      about: "Über uns",
      contact: "Kontakt",
      editorial: "Redaktionsrichtlinien",
      privacy: "Datenschutz",
      terms: "AGB",
    },
    languages: "Sprachen",
  },
  // Home Page
  home: {
    hero: {
      h1: "CSSBuy Spreadsheet – Produkte, Verkäufer und Einkaufsratgeber",
      subtitle: "Entdecke CSSBuy Spreadsheet-Ressourcen, Produkte, Verkäufer, QC-Informationen, Versandratgeber und praktische Einkaufstipps an einem Ort.",
      cta1: "CSSBuy Spreadsheet entdecken",
      cta2: "Jetzt Kaufen",
      trust: "Aktualisierte Ratgeber • Organisierte Ressourcen • Praktische Tipps",
    },
    categories: {
      title: "Finde schnell, was du suchst",
      subtitle: "Durchsuche die Kategorien im CSSBuy Spreadsheet",
    },
    whatIs: {
      title: "Was ist CSSBuy Spreadsheet?",
      content: "CSSBuy Spreadsheet ist eine praktische Möglichkeit, Produkte, Verkäufer und Ressourcen im Zusammenhang mit CSSBuy zu organisieren und zu entdecken. Unser Hub bündelt Listen, Kategorien, QC-Informationen, Versanddetails und Ratgeber an einem Ort, um deine Recherche zu erleichtern. Ob du nach Sneakern, Hoodies, Accessoires oder Parfüm suchst, das CSSBuy Spreadsheet hilft dir, die Welt des internationalen Einkaufens mit Klarheit und Vertrauen zu navigieren.",
      cta: "Die CSSBuy Spreadsheet Liste entdecken",
    },
    guides: {
      title: "Beliebte CSSBuy Ratgeber",
      items: [
        { title: "CSSBuy Review", desc: "Ehrliche Bewertung der CSSBuy Plattformfunktionen und Erfahrung" },
        { title: "CSSBuy Shipping Cost", desc: "Kompletter Versandkostenratgeber und Methodenvergleich" },
        { title: "Is CSSBuy Legit?", desc: "Sicherheitsanalyse und Vertrauensverifizierungsratgeber" },
        { title: "CSSBuy Warehouse", desc: "Wie Lagerung und Verarbeitung im Warehouse funktionieren" },
        { title: "CSSBuy Coupon", desc: "Wie man CSSBuy Rabattcodes findet und verwendet" },
        { title: "CSSBuy QC Guide", desc: "QC-Fotoratgeber und Inspektionstipps" },
      ],
    },
    whyUs: {
      title: "Warum unser CSSBuy Spreadsheet nutzen?",
      content: "Unser Ziel ist es, nützliche Informationen in einem einfach durchsuchbaren Format zu organisieren. Der Inhalt ist nach Suchabsicht, Kategorie und Thema strukturiert, um dir zu helfen, schnell die richtige Ressource zu finden.",
      features: [
        { title: "Organisiert", desc: "Alle Ressourcen nach Kategorie und Absicht sortiert" },
        { title: "Praktisch", desc: "Umsetzbare Tipps und Schritt-für-Schritt-Anleitungen" },
        { title: "Aktualisiert", desc: "Regelmäßig aktualisierter Inhalt und Links" },
        { title: "Transparent", desc: "Keine gefälschten Bewertungen oder irreführenden Behauptungen" },
      ],
    },
    articles: {
      title: "Neueste CSSBuy Artikel",
      subtitle: "Lese detaillierte SEO-Ratgeber und Ressourcen",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      items: [
        { q: "Was ist CSSBuy Spreadsheet?", a: "CSSBuy Spreadsheet ist ein organisierter Ressourcen-Hub, der Käufern hilft, Produkte, Verkäufer, Versandratgeber und QC-Informationen im Zusammenhang mit CSSBuy an einem Ort zu finden." },
        { q: "Ist CSSBuy legitim und sicher?", a: "CSSBuy ist ein bekannter Proxy-Kaufservice. Unsere Ratgeber helfen dir, Sicherheit zu verifizieren, QC-Fotos zu prüfen und Best Practices für sichere Transaktionen zu folgen." },
        { q: "Wie finde ich Produkte auf CSSBuy?", a: "Nutze die Kategoriefilter oder Suchfunktion im CSSBuy Spreadsheet, um Produkte nach Typ, Verkäufer oder Preisspanne zu durchsuchen." },
        { q: "Bietet CSSBuy Coupons an?", a: "Ja, CSSBuy bietet gelegentlich Coupon-Codes und Rabatte an. Unser Ratgeber zeigt dir, wo du die neuesten CSSBuy-Coupons findest." },
      ],
    },
    safety: {
      title: "CSSBuy Safety Center",
      content: "Lerne, wie du verdächtige Links erkennst, deine Informationen schützt, Seiten verifizierst, bevor du Zahlungsdaten eingibst, Versandrisiken verstehst und mögliche Betrugsfälle oder gefälschte Websites vermeidest. Überprüfe immer die Website-URL, bevor du Zahlungs- oder Kontoinformationen eingibst.",
      cta: "Sicherheitszentrum besuchen",
    },
    finalCta: {
      title: "Bereit, das CSSBuy Spreadsheet zu erkunden?",
      content: "Finde Produkte, Verkäufer und CSSBuy-Ressourcen an einem Ort.",
      cta: "CSSBuy Spreadsheet entdecken",
      secondary: "Unsere Hauptseite besuchen",
    },
    products: {
      title: "Produkte durchsuchen",
      subtitle: "Entdecke ausgewählte Produkte aus unserem Hauptkatalog",
      viewAll: "Alle Produkte anzeigen",
    },
  },
  // Article Page
  article: {
    meta: {
      author: "CSSBuy Spreadsheet Team",
      published: "Veröffentlicht",
      updated: "Aktualisiert",
      readingTime: "Min. Lesezeit",
    },
    related: "Verwandte Artikel",
    toc: "Inhaltsverzeichnis",
    cta: "CSSBuy Spreadsheet entdecken",
    comparisonTable: "Vergleichstabelle",
    faqTitle: "FAQ",
    readyToExplore: "Bereit, das CSSBuy Spreadsheet zu erkunden?",
    findResources: "Finde Produkte, Verkäufer und Ressourcen an einem Ort.",
  },
  // Categories
  categories: [
    { name: "Shoes", slug: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { name: "Hoodies/Sweaters", slug: "hoodies", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
    { name: "T-Shirts", slug: "t-shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
    { name: "Jackets", slug: "jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
    { name: "Pants/Shorts", slug: "pants", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
    { name: "Headwear", slug: "headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
    { name: "Sets", slug: "sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
    { name: "Underwear/Underpants", slug: "underwear", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
    { name: "Jersey", slug: "jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
    { name: "Accessories", slug: "accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
    { name: "Bags", slug: "bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
    { name: "Belts", slug: "belts", url: "https://kaspreadsheet.com/category-922-Belts.html" },
    { name: "Perfumes", slug: "perfumes", url: "https://kaspreadsheet.com/category-923-Perfumes.html" },
    { name: "Other Stuff", slug: "other", url: "https://kaspreadsheet.com/category-924-Other+Stuff.html" },
  ],
  // Articles list
  articlesList: [
    {
      slug: "cssbuy-spreadsheet-2026-complete-guide",
      title: "CSSBuy Spreadsheet 2026: Kompletter Produkt- und Verkäufer-Ratgeber",
      desc: "Der umfassendste Ratgeber zur Nutzung von CSSBuy Spreadsheet zum Finden von Produkten, Verkäufern und Versandressourcen in 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-review-2026",
      title: "CSSBuy Review 2026: Ist CSSBuy legitim und sicher?",
      desc: "Eine ehrliche Bewertung der Funktionen, Gebühren, Sicherheit und Gesamterfahrung von CSSBuy für internationale Käufer in 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-shipping-cost-2026",
      title: "CSSBuy Shipping Cost 2026: Kompletter Versandratgeber",
      desc: "Eine detaillierte Aufschlüsselung der CSSBuy-Versandkosten, Methoden und Tipps zur Reduzierung internationaler Versandgebühren.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-warehouse-guide",
      title: "CSSBuy Warehouse Guide: Lagerung, QC und Versand",
      desc: "So funktioniert das CSSBuy-Lager, einschließlich Lagerung, Qualitätskontrolle, Konsolidierung und Versandabwicklung.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-qc-guide",
      title: "CSSBuy QC Guide: So liest du Qualitätskontroll-Fotos",
      desc: "Lerne, wie du CSSBuy-Qualitätskontroll-Fotos liest, um Produkte vor dem internationalen Versand zu überprüfen.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-coupon-guide",
      title: "CSSBuy Coupon Guide 2026: So funktionieren Rabatte",
      desc: "So findest und nutzt du CSSBuy-Coupons, Rabattcodes und Aktionen, um bei Gebühren und Versand zu sparen.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-buying-guide",
      title: "CSSBuy Buying Guide: Komplettes Anfänger-Tutorial",
      desc: "Ein Schritt-für-Schritt-Anfänger-Tutorial von deiner ersten Bestellung bis zum Erhalt deines Pakets.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-seller-guide",
      title: "CSSBuy Seller Guide: So findest du seriöse Verkäufer",
      desc: "Praktische Tipps, um seriöse Verkäufer zu finden, die Reputation von Shops zu bewerten und häufige Fehler zu vermeiden.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-vs-superbuy",
      title: "CSSBuy vs Superbuy: Welcher Proxy-Service ist besser?",
      desc: "Ein direkter Vergleich von CSSBuy und Superbuy zu Gebühren, Versand, Lager und Kundensupport.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-product-search-guide",
      title: "CSSBuy Product Search Guide: So findest du Artikel",
      desc: "So suchst du effektiv nach Produkten mit dem CSSBuy Spreadsheet und den Kategoriefiltern.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-alternatives",
      title: "CSSBuy Alternatives: Beste Proxy-Services im Vergleich",
      desc: "Ein Vergleich der besten CSSBuy-Alternativen für internationales Proxy-Shopping in 2026.",
      date: "2026-08-27",
    },
  ],
  // 404
  notFound: {
    title: "Seite nicht gefunden",
    desc: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    back: "Zurück zur Startseite",
  },
  // Products Page
  products: {
    title: "Alle Produkte",
    subtitle: "Durchsuche den vollständigen Produktkatalog, der über CSSBuy Spreadsheet verfügbar ist.",
    filterBy: "Nach Kategorie filtern",
    allCategories: "Alle Kategorien",
    buyNow: "Jetzt kaufen",
    showing: "Angezeigt",
    products: "Produkte",
    noProducts: "Keine Produkte in dieser Kategorie gefunden.",
  },
};